// src/context/ProgramContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { supabase } from "../supabaseClient";

const ProgramContext = createContext();

export const useProgram = () => useContext(ProgramContext);

export const ProgramProvider = ({ userId, children }) => {
  const [programs, setPrograms] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState(null);

  useEffect(() => {
    if (!userId) return;

    const fetchPrograms = async () => {
      try {
        const { data, error } = await supabase
          .from("user_program_follows")
          .select("program_id, programs(name,sport)")
          .eq("user_id", userId);

        if (error) throw error;
        setPrograms(data || []);

        // Default selected program
        if (data && data.length > 0) {
          setSelectedProgram({
            id: data[0].program_id,
            name: data[0].programs.name,
            sport: data[0].programs.sport
          });
        }
      } catch (err) {
        console.error("Error fetching programs:", err.message);
      }
    };

    fetchPrograms();
  }, [userId]);

  return (
    <ProgramContext.Provider value={{ programs, selectedProgram, setSelectedProgram }}>
      {children}
    </ProgramContext.Provider>
  );
};
